/**
 * FOTOS ALS WEBP — im Browser, vor dem Hochladen.
 *
 * Antoine am 14.10.2026: „Alle neuen Fotos webp komprimieren." Gilt für die Fotos, die Gäste auf
 * den Angebotsseiten sehen (Hero, Karten-Fotos, Bilder der Inhaltsbereiche). Bewusst NICHT für das
 * Logo (muss PNG sein, es landet im PDF) und nicht für das Foto des Ansprechpartners (geht in
 * Mails, Outlook zeigt kein WebP) — dort bleiben die eigenen Wandler in settings.tsx.
 *
 * Nur JPEG/PNG werden gewandelt; SVG, GIF und schon vorhandenes WebP gehen unverändert hoch.
 * Scheitert die Umwandlung, kann der Browser kein WebP erzeugen (älteres Safari liefert dann
 * stillschweigend PNG) oder wird das Ergebnis nicht kleiner, geht das Original hoch.
 */
export async function alsWebpWandeln(file: File, maxKante = 2400, qualitaet = 0.8): Promise<File> {
  if (file.type !== "image/jpeg" && file.type !== "image/png") return file;
  try {
    const bild = await createImageBitmap(file);
    try {
      const faktor = Math.min(1, maxKante / Math.max(bild.width, bild.height));
      const leinwand = document.createElement("canvas");
      leinwand.width = Math.round(bild.width * faktor);
      leinwand.height = Math.round(bild.height * faktor);
      const stift = leinwand.getContext("2d");
      if (!stift) return file;
      stift.drawImage(bild, 0, 0, leinwand.width, leinwand.height);
      const blob = await new Promise<Blob | null>((fertig) => leinwand.toBlob(fertig, "image/webp", qualitaet));
      if (!blob || blob.type !== "image/webp" || blob.size >= file.size) return file;
      return new File([blob], file.name.replace(/\.[^.]+$/, "") + ".webp", { type: "image/webp" });
    } finally {
      bild.close();
    }
  } catch {
    return file;
  }
}
